module.exports = __webpack_public_path__ + "img/oman_net.e4ddcf68.png";